import { Action } from '@ngrx/store';
import { Jobsite, ProductLine, Pod } from '@ordersnproducts/modules/orders-and-product-catalog/models';

export enum GlobalFiltersActionTypes {
  SELECT_JOBSITE = '[GlobalFilters] Select Jobsite',
  SET_JOBSITES = '[GlobalFilters] Set Jobsites',
  SET_ALL_JOBSITES = '[GlobalFilters] Set All Jobsites',
  SET_JOBSITE_LOADER = '[GlobalFilters] Set Jobsites Loader',
  SET_JOBSITE_FILTER = '[GlobalFilters] Set Jobsites Filter',
  SELECT_PRODUCT_LINES = '[GlobalFilters] Select Product Lines',
  SET_PRODUCT_LINES = '[GlobalFilters] Set Product Lines',
  SET_ACTIVE_PRODUCT_LINES = '[GlobalFilters] Set Active Product Lines',
  SET_PRODUCT_LINE_LOADER = '[GlobalFilters] Set Product Line Loader',
  SET_SELECTING_JOBSITE = '[GlobalFilters] Set Selecting Jobsite',
  SELECT_POD = '[GlobalFilters] Select Pod',
  SET_PODS = '[GlobalFilters] Set Pods',
  SET_PODS_LOADER = '[GlobalFilters] Set Pods Loader',
}

export class SelectJobsite implements Action {
  readonly type = GlobalFiltersActionTypes.SELECT_JOBSITE;

  constructor(public customerId: number, public jobsiteId: number) {}
}

export class SetJobsites implements Action {
  readonly type = GlobalFiltersActionTypes.SET_JOBSITES;

  constructor(public customerId: number, public jobsites: Jobsite[]) {}
}

export class SetAllJobsites implements Action {
  readonly type = GlobalFiltersActionTypes.SET_ALL_JOBSITES;

  constructor(public customerId: number, public jobsites: Jobsite[]) {}
}

export class SetJobsiteFilter implements Action {
  readonly type = GlobalFiltersActionTypes.SET_JOBSITE_FILTER;

  constructor(public payload: string) {}
}

export class SetJobsiteLoader implements Action {
  readonly type = GlobalFiltersActionTypes.SET_JOBSITE_LOADER;

  constructor(public payload: boolean) {}
}

export class SetSelectingJobsite implements Action {
  readonly type = GlobalFiltersActionTypes.SET_SELECTING_JOBSITE;

  constructor(public payload: boolean) {}
}

export class SelectProductLines implements Action {
  readonly type = GlobalFiltersActionTypes.SELECT_PRODUCT_LINES;

  constructor(public customerId: number, public productLinesIds: number[]) {}
}

export class SetProductLines implements Action {
  readonly type = GlobalFiltersActionTypes.SET_PRODUCT_LINES;

  constructor(public customerId: number, public productLines: ProductLine[]) {}
}

export class SetActiveProductLines implements Action {
  readonly type = GlobalFiltersActionTypes.SET_ACTIVE_PRODUCT_LINES;

  constructor(public jobsiteId: number, public productLinesIds: number[]) {}
}

export class SetProductLineLoader implements Action {
  readonly type = GlobalFiltersActionTypes.SET_PRODUCT_LINE_LOADER;

  constructor(public payload: boolean) {}
}

export class SelectPod implements Action {
  readonly type = GlobalFiltersActionTypes.SELECT_POD;

  constructor(public customerId: number, public podId: number) {}
}
export class SetPodsLoader implements Action {
  readonly type = GlobalFiltersActionTypes.SET_PODS_LOADER;

  constructor(public payload: boolean) {}
}

export class SetPods implements Action {
  readonly type = GlobalFiltersActionTypes.SET_PODS;

  constructor(public customerId: number, public jobsiteId: number, public pods: Pod[]) {}
}

export type GlobalFiltersActions =
  | SelectJobsite
  | SetJobsites
  | SetAllJobsites
  | SelectProductLines
  | SetProductLines
  | SetJobsiteLoader
  | SetSelectingJobsite
  | SetProductLineLoader
  | SetActiveProductLines
  | SetJobsiteFilter
  | SelectPod
  | SetPodsLoader
  | SetPods;
